<div
    *ngIf="dates?.length"
    class="item"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
    data-testid="resource-detail-occasion"
>
    <div
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
        class="dates"
        [ngClass]="{ 'm-0': canShowMore ? index > 1 : false }"
        *ngFor="let occ of dates; let index = index"
    >
        <div *ngIf="canShowMore ? index < 2 : true" class="w-100" fxLayout="column" fxLayoutAlign="start start">
            <ng-container *ngIf="occ.application_start_date">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                    <span i18n>Application</span><span *ngIf="dates.length > 1">{{ index + 1 }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span class="capitaliza">{{ occ.application_start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <ng-container *ngIf="occ.application_end_date">
                        <span i18n>To:</span>
                        <span class="capitaliza">{{ occ.application_end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    </ng-container>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="occ.start_date">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                    <span i18n>Occasion</span><span *ngIf="dates.length > 1">{{ index + 1 }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span class="capitaliza">{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <ng-container *ngIf="occ.end_date">
                        <span i18n>To:</span>
                        <span class="capitaliza">{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    </ng-container>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-container *ngIf="canShowMore">
        <div (click)="showMoreDates()" *ngIf="dates?.length > 2" class="dates more">
            <span>Show {{ dates?.length - 2 }} more</span>
        </div>
    </ng-container>
</div>
<ng-template #all_occasion_dates>
    <div
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
        class="dates-res-occasions"
        *ngFor="let occ of dates; let index = index"
    >
        <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
            <ng-container *ngIf="occ.application_start_date">
                <span>Application Open:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.application_start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <ng-container *ngIf="occ.application_end_date">
                        <span i18n>To:</span>
                        <span>{{ occ.application_end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    </ng-container>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="occ.start_date">
                <span>Course Starts:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <ng-container *ngIf="occ.end_date">
                        <span i18n>To:</span>
                        <span>{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    </ng-container>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
